import {
  ChangeDetectorRef,
  Component,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { Observable, of } from 'rxjs';
import { ProductCategoryDetailsDocumentComponent } from '../product-category-details-tab/product-category-documents/product-category-details-documents.component';
import { ProductCategoryDetailsClaimTypesComponent } from '../product-category-details-tab/product-category-details-claim-types/product-category-details-claim-types.component';
import { TabsContentGenericDetails } from '../../../../../shared/models/tabs-content-generic-details';

@Component({
  selector: 'app-product-category-tabs-details',
  templateUrl: './product-category-tabs-details.component.html',
  styleUrls: ['./product-category-tabs-details.component.scss'],
  standalone: false,
})
export class ProductCategoryTabsDetailsComponent implements OnInit, OnChanges {
  active = 1;

  tabsContent$: Observable<TabsContentGenericDetails[]> = of([]);
  tabsInit: TabsContentGenericDetails[] = [
    {
      title: 'PRODUCTLINE_TABS_DOCUMENTS',
      index: 1,
      name: 'insuranceDocuments',
      component: ProductCategoryDetailsDocumentComponent,
    },
    {
      title: 'PRODUCT_CATEGORY_TABS_CLAIM_TYPES',
      index: 2,
      name: 'claimTypes',
      component: ProductCategoryDetailsClaimTypesComponent,
    },
  ];

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.tabsContent$ = of(this.tabsInit);
    this.changeDetectorRef.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.tabsContent$ = of(this.tabsInit);
  }

  trackByTabsContent(index: any, item: TabsContentGenericDetails) {
    return item.index;
  }
}
